<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Imported List</h3>
        </div>
        <div class="col-auto float-right ml-auto" v-if="role == 'admin'">
          <button
            v-if="!isUpload"
            @click="toggleIsUpload"
            class="btn btn-link btn-upload"
          >
            <i class="fa fa-upload"></i> Upload Data
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Upload Section  -->
    <div class="section mb-4" v-if="isUpload">
      <div class="align-items-center" style="margin-top: -7px">
        <form id="importForm" @submit.prevent="save" v-if="role == 'admin'">
          <div class="col-md-12">
            <input
              @change="onFileSelected($event)"
              type="file"
              accept=".xlsx,.xls"
              class="custom-file-input"
              id="excelFile"
              ref="excelFile"
              style="cursor: pointer"
              required
              form="importForm"
            />
            <label
              class="custom-file-label"
              for="excelFile"
              style="cursor: pointer"
              >{{ file ? file.name : "Upload file..." }}</label
            >
          </div>
          <div class="col-md-4 pr-0 mt-3">
            <button
              style="margin-left: -10px"
              class="btn btn-sm btn-primary"
              form="importForm"
              :disabled="!file"
            >
              <i class="fa fa-upload"></i> Upload
            </button>

            <button
              v-if="isUpload"
              @click="toggleIsUpload"
              class="btn btn-sm btn-danger"
            >
              <i class="fa fa-times"></i> Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- /Upload Section  -->

    <!-- Table List -->
    <div class="row">
      <div class="col-md-12">
        <!-- Form -->
        <div class="row align-items-center mt-2">
          <div class="col-md-2">Month</div>
          <div class="col-md-2 pl-md-0">
            <select class="custom-select" v-model="month">
              <option value="">All</option>
              <option v-for="month in months" :key="month" :value="month">
                {{ month }}
              </option>
            </select>
          </div>

          <div class="col-md-2"></div>

          <div class="col-md-2 ml-md-4">Year</div>
          <div class="col-md-2 pl-md-0">
            <select class="custom-select" v-model="year">
              <option v-for="year in years" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
          </div>
        </div>

        <div class="row align-items-center mt-3">
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary" @click="search">
              Search
            </button>
          </div>
        </div>
      </div>
      <!-- /Form -->

      <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1 mt-4">
        <table class="table table-bordered custom-table mb-0">
          <thead class="thead-light">
            <tr>
              <th class="text-center action-column">Action</th>
              <th class="group-column">Import Date</th>
              <th>Filename</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in importData" :key="index">
              <td class="action-column text-center">
                <span v-if="data.IsPurge">
                  Purged on {{ data.PurgeDateDisplay }}
                </span>
                <router-link
                  v-else
                  :to="{ name: 'CADOImportDetail', params: { id: data.Id } }"
                >
                  <a class="btn btn-secondary"><span>View</span></a>
                </router-link>
              </td>
              <td class="group-column">{{ data.ImportDateDisplay }}</td>
              <td class="group-column">{{ data.Filename }}</td>
            </tr>

            <tr v-if="importData && !importData.length">
              <td colspan="4" class="text-center">{{ this.noRecordText }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- /Table List -->
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import * as XLSX from "xlsx";

export default {
  data() {
    return {
      importData: [],
      month: "",
      year: "",
      //company: "",
      department: "",
      userId: "All",
      months: [],
      years: [],
      //companies: [],
      departments: [],
      employees: [],
      status: config.TIMESHEET_STATUS_DRAFT,
      noRecordText: config.NO_RECORD_TEXT,
      isUpload: false,
      file: null,
      errors: [],

      //for pagination
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  methods: {
    toggleIsUpload() {
      this.isUpload = !this.isUpload;
    },
    reset() {
      this.file = null;
      this.errors = [];
    },
    onFileSelected(e) {
      this.reset();
      this.file = e.target.files[0];
      if (
        this.file &&
        (this.file.name.split(".").pop() == "xlsx" ||
          this.file.name.split(".").pop() == "xls")
      ) {
        let fileReader = new FileReader();
        fileReader.readAsBinaryString(this.file);
      }
    },
    save() {
      //validate file extension;
      if (
        this.file &&
        this.file.name.split(".").pop() != "xlsx" &&
        this.file.name.split(".").pop() != "xls"
      ) {
        this.$swal("Please select an xlsx file", { icon: "error" });
        return;
      }
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to upload the data?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          //reset
          this.errors = [];

          let param = {
            Filename: this.file.name,
            Data: [],
            Token: this.token,
          };

          //process
          let fileReader = new FileReader();

          fileReader.readAsBinaryString(this.file);
          fileReader.onload = (event) => {
            let binaryData = event.target.result;
            //console.log("binaryData", binaryData);
            let workbook = XLSX.read(binaryData, { type: "binary" });
            // console.log(workbook);
            let data = XLSX.utils.sheet_to_json(
              workbook.Sheets[workbook.SheetNames[0]],
              {
                defval: "",
                header: "A",
                blankrows: true,
              }
            );

            for (let i = 2; i < data.length; i++) {
              let row = data[i];
              let rowData = {
                Date: row["F"],
                EmployeeID: row["D"],
                ImportedHoursMonSat: row["J"] == 906 ? row["G"] : 0,
                ImportedHoursSunPH: row["J"] == 907 ? row["G"] : 0,
                ImportedHours: row["G"],
                Fab: row["P"],
                ServiceOrder: row["B"],
                Purpose: row["C"],
              };

              param.Data.push(rowData);
            }

            this.$store.state.isLoading = true;
            API.uploadCADOData(param)
              .then((response) => {
                this.$store.state.isLoading = false;
                if (response.data.success) {
                  this.$swal(response.data.message, { icon: "success" });
                  this.isUpload = false;

                  this.search();
                } else {
                  this.$swal(response.data.message, { icon: "error" });
                }
              })
              .catch((error) => {
                this.$store.state.isLoading = false;
                this.$swal(error.response.data.Message, { icon: "error" });
              });
          };
          //clear file after upload
          this.file = null;
          this.$refs.excelFile.value = null;
        }
      });
    },
    /*getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;

            this.company = this.companies[0].CompanyName;
            console.log(this.companies);
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },*/
    getYears() {
      let date = new Date();
      let minYear = date.getFullYear() - 5;
      this.years = [];
      for (let year = date.getFullYear(); year > minYear; year--) {
        this.years.push(year);
      }
    },
    getMonths() {
      this.months = [];
      this.month = "";

      this.months.push("Jan");
      this.months.push("Feb");
      this.months.push("Mar");
      this.months.push("Apr");
      this.months.push("May");
      this.months.push("Jun");
      this.months.push("Jul");
      this.months.push("Aug");
      this.months.push("Sep");
      this.months.push("Oct");
      this.months.push("Nov");
      this.months.push("Dec");
    },
    search() {
      let param = {
        Token: this.token,
        Month: this.month,
        Year: this.year,
      };
      this.$store.state.isLoading = true;
      API.searchImportList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.isEmpty) {
              this.importData = [];
            } else {
              this.importData = response.data.record;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },

  created() {
    if (this.role == "admin") {
      this.getMonths();
      this.getYears();

      let date = new Date();
      this.month = this.months[date.getMonth()];
      this.year = date.getFullYear();

      this.search();

      //this.getCompanies();
    }
  },
};
</script>

<style scoped>
.group-column {
  width: 12%;
}
</style>


// WEBPACK FOOTER //
// src/components/Attendance/CADOImport.vue